module.exports = __webpack_public_path__ + "img/checkStep.a4ac451d.svg";